import * as types from '../const/action.types';
import { get, put, post, del } from '../api/_basic';

export function loadDisplays(local, loading) {
    return async (dispatch) => {
        dispatch(displaysHasErrored(false, ''));
        dispatch(displaysIsLoading(loading));
        return get(
            local
                ? `${process.env.REACT_APP_API_DISPLAYBYLOCAL}/${local}`
                : `${process.env.REACT_APP_API_DISPLAY}`,
        )
            .then((response) => {
                dispatch(displaysIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(displaysHasErrored(false, ''));
                dispatch(loadDisplaysSuccess(items));
            })
            .catch((error) => {
                dispatch(displaysIsLoading(false));
                dispatch(displaysHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addDisplay(display) {
    return async (dispatch) => {
        dispatch(displayIsSaving(true));
        return post(`${process.env.REACT_APP_API_DISPLAY}`, display)
            .then((response) => {
                dispatch(displayIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function editDisplay(display) {
    return async (dispatch) => {
        dispatch(displayIsSaving(true));
        return put(`${process.env.REACT_APP_API_DISPLAY}/${display.id}`, display)
            .then((response) => {
                dispatch(displayIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function throttle(display, throttle, estado) {
    return async (dispatch) => {
        dispatch(displaysIsLoading(true));
        return put(
            `${process.env.REACT_APP_API_DISPLAY}/${display}/` + (throttle ? 'unthrottle' : 'ping'),
        )
            .then((response) => {
                dispatch(displaysIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                dispatch(displaysIsLoading(false));
                console.log(error);
                throw error;
            });
    };
}

export function deleteDisplay(display) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_DISPLAY}/${display}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadInfo(display) {
    return async function(dispatch) {
        dispatch(displaysHasErrored(false, ''));
        dispatch(displaysIsLoading(true));
        return get(`${process.env.REACT_APP_API_DISPLAY}/${display}`)
            .then((response) => {
                dispatch(displaysIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(displaysHasErrored(false, ''));
                dispatch(loadDisplaySuccess(item));
            })
            .catch((error) => {
                //throw error;
                dispatch(displaysHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function getURLRegister(display) {
    return async function(dispatch) {
        return put(`${process.env.REACT_APP_API_DISPLAY}/${display}/hueauthurl`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function callback(code, state) {
    return async function(dispatch) {
        return put(`${process.env.REACT_APP_API_DISPLAY}/hueauth`, {
            code: decodeURIComponent(code),
            state: decodeURIComponent(state),
        })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function loadDisplaySuccess(data) {
    return {
        type: types.LOAD_DISPLAY_SUCCESS,
        data,
    };
}

export function loadDisplaysSuccess(data) {
    return {
        type: types.DISPLAYS_SUCCESS,
        data,
    };
}

export function displaysHasErrored(bool, message) {
    return {
        type: types.DISPLAYS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function displaysIsLoading(bool) {
    return {
        type: types.DISPLAYS_IS_LOADING,
        isLoading: bool,
    };
}

export function displayIsSaving(bool) {
    return {
        type: types.DISPLAYS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/display.actions.js